import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'reduceName',
  standalone: false,
})
export class ReduceNamePipe implements PipeTransform {
  transform(value: string | undefined, threshold = 0): string | null {
    if (!value || typeof value !== 'string') {
      return null;
    }

    if (value.length <= threshold) {
      return value;
    }

    const words = value.split(' ');
    if (words.length === 1) {
      return words[0];
    }

    return `${words[0]} ${words[words.length - 1]}`;
  }
}
